var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"1"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"140"}}),_vm._v(" Login-Vorgang ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }